import convertObjectToCanvas from './convertObjectToCanvas'

const convertMultipleToCanvas = async (ids) => {
  const canvases = await Promise.all(ids.map((id) => convertObjectToCanvas(id)))

  return ids.reduce((acc, id, index) => {
    acc[id] = canvases[index]
    return acc
  }, {})
}

export default convertMultipleToCanvas
